import script from "./ExtinguisherTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./ExtinguisherTabs.vue?vue&type=script&setup=true&lang=js"

import "./ExtinguisherTabs.vue?vue&type=style&index=0&id=a449038c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a449038c"]])

export default __exports__